export var loadHistoryState = function () {
    var state = history.state;
    if (state === null || typeof state !== 'object') {
        return null;
    }
    return state;
};
